import React from 'react';
//import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';

const FileInputRedux = ({ input, type, meta, label }) => {
    // const { mime } = props;
    const handleChange = (event, input) => {
        event.preventDefault();
        let imageFile = event.target.files[0];
        if (imageFile) {
          const localImageUrl = URL.createObjectURL(imageFile);
          const imageObject = new window.Image();
    
          imageObject.onload = () => {
            imageFile.width = imageObject.naturalWidth;
            imageFile.height = imageObject.naturalHeight;
            input.onChange(imageFile);
            URL.revokeObjectURL(imageFile);
          };
          imageObject.src = localImageUrl;
        }
      };
    return (
      <div>
            <Typography variant="h6" gutterBottom>
                { label }
            </Typography>
        <input
          name={input.name}
          required
          type={type}
        //   accept={mime}
        accept="image/*"
          onChange={event => handleChange(event, input)}
        />
      </div>
    );
  };

FileInputRedux.propTypes = {
    
};

export default FileInputRedux;